'use client'

import useAutoGeolocation from '../../_hooks/useAutoGeolocation'
import Mobile from './mobile'

function AutoGeolocate() {
  const { activePoint, open, dismissModal, isDisabled } = useAutoGeolocation()

  if (isDisabled) {
    return null
  }

  return (
    <Mobile
      open={open}
      activePoint={activePoint}
      onClose={dismissModal}
    />
  )
}

export default AutoGeolocate
